import { selectFeatureFlags } from 'core/userContext';
import { useSelector } from 'react-redux';
import { useHtmlLoaderContext } from '../../../contexts/HtmlLoaderContext';
import { CreativeLibraryButton } from './CreativeLibraryButton';
import { MovableInkButton } from './MovableInkButton';
import { DynamicContentBuilderButton } from './DynamicContentBuilderButton';
import { LoadHtmlButton } from './LoadHtmlButton';
import { SnippetSelectorButton } from './SnippetSelectorButton';

export const InsertButtons = () => {
  const { canLoadHTML } = useHtmlLoaderContext();
  const { DynamicContentBuilder, MovableInk } = useSelector(selectFeatureFlags);

  return (
    <>
      {canLoadHTML && <LoadHtmlButton />}
      <CreativeLibraryButton />
      {MovableInk && <MovableInkButton />}
      {DynamicContentBuilder && <DynamicContentBuilderButton />}
      <SnippetSelectorButton />
    </>
  );
};
